<template>
  <nav v-if="1 < pages" class="pagination-nav">
    <ul v-if="1 < pages" class="pagination">
      <li class="page-item" v-bind:class="{disabled: _page == 1}">
        <a class="page-link prev-link" href="javascript:void(0);" @click="prev"><span>{{prevBtnText}}</span></a>
      </li>
      <template v-if="pages <= max">
        <template v-for="n in pages">
          <li class="page-item" v-bind:class="{active: _page == n}">
            <a class="page-link" v-bind:href="deeplink" @click="goto(n, $event)"><span>{{n}}</span></a>
          </li>
        </template>
      </template>
      <template v-else-if="_page <= (max - 3)">
        <template v-for="n in (max - 2)">
          <li class="page-item" v-bind:class="{active: _page == n}">
            <a class="page-link" v-bind:href="deeplink" @click="goto(n, $event)"><span>{{n}}</span></a>
          </li>
        </template>
        <li class="page-item disabled"><span class="page-link">&#8230;</span></li>
        <li class="page-item">
          <a class="page-link" v-bind:href="deeplink" @click="goto(pages, $event)"><span>{{pages}}</span></a>
        </li>
      </template>
      <template v-else-if="(pages - max + 3) < _page">
        <li class="page-item">
          <a class="page-link" v-bind:href="deeplink" @click="goto(1, $event)"><span>1</span></a>
        </li>
        <li class="page-item disabled"><span class="page-link">&#8230;</span></li>
        <template v-for="n in (max - 2)">
          <li class="page-item" v-bind:class="{active: _page == (start+n)}">
            <a class="page-link" v-bind:href="deeplink" @click="goto((start+n), $event)"><span>{{(start+n)}}</span></a>
          </li>
        </template>
      </template>
      <template v-else>
        <li class="page-item">
          <a class="page-link" v-bind:href="deeplink" @click="goto(1, $event)"><span>1</span></a>
        </li>
        <li class="page-item disabled"><span class="page-link">&#8230;</span></li>
        <template v-for="n in (max - 4)">
          <li class="page-item" v-bind:class="{active: _page == (start+n)}">
            <a class="page-link" v-bind:href="deeplink" @click="goto((start+n), $event)"><span>{{(start+n)}}</span></a>
          </li>
        </template>
        <li class="page-item disabled"><span class="page-link">&#8230;</span></li>
        <li class="page-item">
          <a class="page-link" v-bind:href="deeplink" @click="goto(pages, $event)"><span>{{pages}}</span></a>
        </li>
      </template>
      <li class="page-item" v-bind:class="{disabled: _page == pages}">
        <a class="page-link next-link"  href="javascript:void(0);" @click="next"><span>{{nextBtnText}}</span></a>
      </li>
    </ul>
  </nav>
</template>

<script>
  export default {
    name: "paginator",
    props: {
      pages: Number,
      page: Number,
      max: {
        type: Number,
        default: 9
      },
      deeplink: {
        type: String,
        default: "javascript:void(0);"
      },
      nextBtnText: {
        type: String,
        default: "Next"
      },
      prevBtnText: {
        type: String,
        default: "Previous"
      }
    },

    model: {
      prop: 'page',
      event: 'change'
    },

    computed: {
      _page: {
        get() { return this.page; },
        set(value) {
          this.$emit('change', value);
        }
      },
      start() {
        if( this.pages <= this.max ) {
          return 1;
        } else if( this._page <= (this.max - 3) ) {
          return 1;
        } else if( (this.pages - this.max + 3) < this._page ) {
          return this.pages - this.max + 2;
        } else {
          return this._page - Math.round((this.max - 4) / 2);
        }
      }
    },

    methods: {
      goto(p, e) {
        e.preventDefault();
        this._page = p;
      },
      prev(e) {
        e.preventDefault();
        if( 1 < this._page ) {
          this._page--;
        }
      },
      next(e) {
        e.preventDefault();
        if( this._page < this.pages ) {
          this._page++;
        }
      },
    }
  }
</script>

<style scoped>

</style>